<template>
  <div class="container">
    <div v-for="(i, index) in alerts" class="alert" :class="i.type" align="left" role="alert">{{i.text}}</div>
    <div v-if="loading" class="jumbotron">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else class="row">
      <div class="col-sm">
        <div class="jumbotron">
          <h1 class="display-4">¡Hola {{ this.user.username | capitalize }}!</h1>
          <p class="lead">{{ msg }}</p>
          <hr class="">
          <div v-if="clicked" class="alert alert-success" align="left" role="alert">Su <b>{{action}}</b> ha sido registrada correctamente</div>
          <div v-else-if="sending" class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <a v-else class="btn btn-danger btn-lg" href="#" role="button" @click="switchState">{{ this.action }}</a>
          <hr>
          <h4><span class="badge badge-dark"> {{ this.user.name }} {{ this.user.surname }} {{ this.user.surname2 }}</span></h4>
        </div>
        <div class="jumbotron">
          <h1 class="display-1">{{ this.clock }}</h1>
          <h1>{{ this.date }}</h1>
        </div>
      </div>
      <div class="col-sm">
        <table class="table table-striped table-sm table-dark">
          <thead>
            <tr>
              <th scope="col">Fecha</th>
              <th scope="col">Hora</th>
              <th scope="col">Acción</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i, index) in controls">
              <td>{{i.date}}</td>
              <td>{{i.time}}</td>
              <td>{{i.action}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
    function padZero(number) {
        if (number > 9) return number;
        if (number >= 0) return "0"+number;
        return "00";
    }
    function getDate(){
        var date = new Date();
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = date.getFullYear();

        date = dd + '/' + mm + '/' + yyyy;
        return date;
    }
    function getClock(){
        var date = new Date();
        var hours = padZero(date.getHours());
        var minutes = padZero(date.getMinutes());
        var seconds = padZero(date.getSeconds());
        return hours+":"+minutes+":"+seconds;
    }

    import settings from "../settings";
    import axios from 'axios';
    var API_URL = settings.API_URL + "assist/";
    export default {
        name: 'AssistUser',
        data () {
            return {
                msg: '¡Bienvenido al control de asistencia!',
                controls: [],
                date: getDate(),
                clock: getClock(),
                ticker: null,
                user: '',
                state: false,
                loading: true,
                sending: false,
                clicked: false,
                alerts:[{type:'alert-warning', text:'Versión BETA -> ¡Informar inmediatamente de cualquier comportamiento extraño!'}]
            }
        },
        computed:{
            action() {
                if(this.state) {
                    return 'SALIDA'
                }
                return 'ENTRADA'
            }
        },
        methods:{
            getUser() {
                axios.post(API_URL + 'getUserByName.php', {
                    employee: this.$route.params.employee
                }).then(response => {
                    this.user = response.data
                    this.getControls()
                    this.getLastState()
                });
            },
            getLastState() {
              axios.post(API_URL + 'getLastState.php', {
                user: this.user.id
              }).then(response => {
                if(response.data == "ENTRADA"){
                  this.state = true;
                }
                this.loading = false;
              });
            },
            getControls() {
                axios.post(API_URL + 'getControls.php', {
                    user: this.user.id
                }).then((response) => {
                    this.controls = response.data;
                });
            },
            switchState() {
                this.sending = true;
                axios.post(API_URL + 'switchState.php', {
                    user: this.user.id,
                    date: this.date,
                    clock: this.clock,
                    action: this.action
                }).then(response => {
                    this.getControls();
                    this.clicked = true;
                });
            }

        },
        filters: {
            capitalize: function (value) {
                if (!value) return ''
                value = value.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },
        mounted(){
            this.ticker = setInterval(() => {
                this.clock = getClock();
            }, 1000);
            this.getUser();
        },
        watch:{
          $route (to, from){
            this.getUser();
          }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>